import styled, { keyframes } from "styled-components";

const TOK = {
  surface: "rgba(255,255,255,0.72)",
  surfaceDark: "rgba(17,24,39,0.68)",
  border: "rgba(148,163,184,0.35)",
  text: "#0f172a",
  textDark: "#e5e7eb",
  ring: "#6366f1",
  shadow: "0 18px 40px rgba(2,6,23,0.18)",
  shadowDark: "0 18px 40px rgba(0,0,0,0.45)",
  chipBg: "rgba(241,245,249,0.7)",
  chipBgDark: "rgba(30,41,59,0.55)",
  chipText: "#0f172a",
  chipTextDark: "#e5e7eb",
  chipActiveBg: "rgba(238,242,255,0.9)",
  chipActiveBgDark: "rgba(59,130,246,0.18)",
  chipActiveText: "#4338ca",
  chipActiveTextDark: "#93c5fd",
  chipActiveRing: "rgba(99,102,241,0.35)",
};

const popIn = keyframes`
  from { opacity: 0; transform: translateY(6px) scale(0.985); }
  to   { opacity: 1; transform: translateY(0)   scale(1); }
`;

export const FilterBox = styled.div`
  position: relative;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  background: ${TOK.surface};
  border: 1px solid ${TOK.border};
  box-shadow: ${TOK.shadow};
  border-radius: 12px;
  padding: 6px;
  min-width: 220px;
  max-width: 320px;
  animation: ${popIn} 110ms ease-out;
  will-change: transform, opacity;

  &::before {
    --size: 10px;
    content: "";
    position: absolute;
    top: calc(-1 * var(--size) / 2);
    left: calc(var(--arrow-x, 14px) - var(--size) / 2);
    width: var(--size);
    height: var(--size);
    transform: rotate(45deg);
    background: inherit;
    border-left: inherit;
    border-top: inherit;
    filter: drop-shadow(0 2px 2px rgba(2, 6, 23, 0.08));
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const InputWrap = styled.label`
  position: relative;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: rgba(255, 255, 255, 0.55);
  border-radius: 10px;
  padding: 7px 32px 7px 30px;
  transition: border-color 120ms ease, box-shadow 120ms ease,
    background 120ms ease;

  &:focus-within {
    border-color: rgba(96, 165, 250, 0.8);
    box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.22);
    background: rgba(255, 255, 255, 0.75);
  }
`;

export const TextInput = styled.input.attrs({ type: "text" })`
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  color: ${TOK.text};
  font-size: 13px;
  line-height: 20px;

  &::placeholder {
    color: #9ca3af;
  }
`;

export const ClearBtn = styled.button`
  position: absolute;
  right: 4px;
  width: 22px;
  height: 22px;
  border: 0;
  outline: 0;
  border-radius: 999px;
  background: rgba(241, 245, 249, 0.9);
  color: #6b7280;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  transition: transform 80ms ease, background 120ms ease, color 120ms ease;

  &:hover {
    background: rgba(229, 231, 235, 0.95);
    color: #374151;
  }
  &:active {
    transform: translateY(1px) scale(0.98);
  }
`;

export const Segmented = styled.div`
  display: inline-flex;
  gap: 4px;
  border-radius: 999px;
  padding: 3px;
  background: rgba(241, 245, 249, 0.7);
  border: 1px solid rgba(148, 163, 184, 0.35);
`;

export const SegBtn = styled.button`
  position: relative;
  display: inline-grid;
  place-items: center;
  min-width: 34px;
  height: 28px;
  padding: 0 8px;
  border: 0;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  background: rgba(255, 255, 255, 0.9);
  color: #0f172a;
  cursor: pointer;

  &[data-active="true"] {
    background: rgba(238, 242, 255, 0.9);
    color: #4338ca;
    box-shadow: 0 0 0 2px rgba(238, 242, 255, 0.9) inset,
      0 0 0 2px rgba(99, 102, 241, 0.35);
  }

  &:hover {
    filter: brightness(0.98);
  }
  &:active {
    transform: translateY(1px);
  }
  &:focus-visible {
    outline: 2px solid #6366f1;
    outline-offset: 2px;
  }
`;
